"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_random_1 = __importDefault(require("lodash.random"));

function randomNumber(lower, upper) {
  return lodash_random_1.default(lower, upper);
}

exports.randomNumber = randomNumber;